export interface UploadResponse {
  message: string;
  file: UploadedFile;
  entity: string;
  field: string;
}

export interface UploadedFile {
  id: number;
  documentId: string;
  name: string;
  alternativeText: string;
  caption: string;
  width: number;
  height: number;
  formats: Record<string, any>; // ou troque por uma interface se tiver estrutura conhecida
  hash: string;
  ext: string;
  mime: string;
  size: number;
  url: string;
  previewUrl: string | null;
  provider: string;
  provider_metadata: any | null;
  folderPath: string;
  createdAt: string; // pode usar Date se for convertido
  updatedAt: string;
  publishedAt: string;
  locale: string | null;
  s3Key: string;
  s3Bucket: string;
}

export enum contentType {
  ALUNO = 'api::aluno.aluno',
  TURMA = 'api::turma.turma',
  AGENDA = 'api::agenda.agenda',
  ESCOLA = 'api::escola.escola',
  PROFESSOR = 'api::professor.professor',
  MATERIA = 'api::materia.materia',
  GRADE_CURRICULAR = 'api::grade-curricular.grade-curricular',
}

export enum field {
  FOTO = 'foto',
  DOCUMENTOS = 'documentos',
  CERTIFICADOS = 'certificados',
  CONTEUDO = 'conteudo',
  PDFs = 'pdfs',
  CONTRATOS = 'contratos',
  CURRICULO = 'curriculo',
  MATERIAL = 'material',
  ANEXOS = 'anexos',
  LOGO = 'logo',
  FOTO_ESQUERDO = 'foto_esquerdo',
  FOTO_DIREITO = 'foto_direito',
  FOTO_FRONTAL = 'foto_frontal',
}
